/* Reya product page — delivery estimate, complete the look, sticky add to cart, share,
   bundle builder, recently viewed. Vanilla custom elements, no dependencies. */
(() => {
  if (window.__rrProduct) return;
  window.__rrProduct = true;

  const RS = window.ReyaSettings || {};
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const toast = (m) => window.Reya && window.Reya.toast && window.Reya.toast(m);

  /* ---------- money ---------- */
  const formatMoney = (window.ReyaMoney =
    window.ReyaMoney ||
    ((cents, format) => {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      format = format || RS.moneyFormat || '₹{{amount}}';
      const fmt = (n, d, t = ',', dec = '.') => {
        if (isNaN(n) || n == null) return 0;
        const parts = (n / 100).toFixed(d).split('.');
        return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${t}`) + (parts[1] && +parts[1] ? dec + parts[1] : '');
      };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
        switch (k) {
          case 'amount_no_decimals': return fmt(cents, 0);
          case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'");
          case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
          default: return fmt(cents, 2);
        }
      });
    }));

  /* ---------- cart add (shared with rr-cart.js) ---------- */
  window.ReyaCart =
    window.ReyaCart ||
    {
      async add(items, btn) {
        const drawer = document.querySelector('cart-drawer');
        const body = { items };
        if (drawer && drawer.getSectionsToRender) {
          body.sections = drawer.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }
        if (btn) {
          btn.setAttribute('aria-busy', 'true');
          btn.classList.add('is-loading');
          btn.disabled = true;
        }
        try {
          const res = await fetch(`${(window.routes && routes.cart_add_url) || root + 'cart/add'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || data.message);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rr-cart', cartData: data });
          }
          if (drawer && data.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else {
            window.location.href = (window.routes && routes.cart_url) || root + 'cart';
          }
          return data;
        } catch (e) {
          toast(e.message || (window.cartStrings && cartStrings.error) || 'Error');
          return null;
        } finally {
          if (btn) {
            btn.removeAttribute('aria-busy');
            btn.classList.remove('is-loading');
            btn.disabled = false;
          }
        }
      },
    };

  if (!window.__rrAddBound) {
    window.__rrAddBound = true;
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-rr-add]');
      if (!b) return;
      e.preventDefault();
      window.ReyaCart.add([{ id: +b.dataset.rrAdd, quantity: 1 }], b);
    });
  }

  /* ---------- share: copy link ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-rr-copy]');
    if (!b) return;
    const url = b.dataset.rrCopy;
    const done = () => toast(b.dataset.rrCopied || url);
    if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
      navigator.share({ title: document.title, url }).catch(() => {});
    } else if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done);
    else {
      const t = document.createElement('textarea');
      t.value = url;
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (err) {}
      t.remove();
      done();
    }
  });

  const onVariant = (cb) => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      return subscribe(PUB_SUB_EVENTS.variantChange, (ev) => ev && ev.data && cb(ev.data));
    }
    return () => {};
  };

  /* ---------- ATC label + price inside the button (re-applied after Dawn variant updates) ---------- */
  onVariant((d) => {
    const btn = document.getElementById(`ProductSubmitButton-${d.sectionId}`);
    if (!btn) return;
    const label = btn.querySelector('span');
    if (!btn.disabled && btn.dataset.rrLabel && label) label.textContent = btn.dataset.rrLabel;
    const price = btn.querySelector('[data-rr-atc-price]');
    if (price && d.variant) price.lastChild.textContent = ` ${formatMoney(d.variant.price)}`;
  });

  /* ---------- "Gift this charm" toggle (line item property) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-rr-gift-toggle]');
    if (!b) return;
    const panel = document.getElementById(b.getAttribute('aria-controls'));
    if (!panel) return;
    const open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', open);
    b.classList.toggle('is-active', open);
    panel.hidden = !open;
    const t = panel.querySelector('textarea');
    if (t) {
      t.disabled = !open;
      if (open) t.focus();
    }
  });

  /* ---------- delivery estimate ---------- */
  if (!customElements.get('rr-delivery')) {
    customElements.define(
      'rr-delivery',
      class extends HTMLElement {
        connectedCallback() {
          this.cut = +this.dataset.cutoff || 0;
          this.min = +this.dataset.min || 1;
          this.max = Math.max(this.min, +this.dataset.max || this.min);
          this.skipSun = this.dataset.skipSunday === 'true';
          this.offset = parseFloat(this.dataset.offset) || 0;
          const lang = document.documentElement.lang || 'en';
          this.df = new Intl.DateTimeFormat(lang.includes('-') ? lang : `${lang}-IN`, {
            weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC',
          });
          this.render();
          this.timer = setInterval(() => this.render(), 30000);
          const form = this.querySelector('[data-rr-pincode]');
          if (form) form.addEventListener('submit', (e) => { e.preventDefault(); this.checkPin(form); });
        }
        disconnectedCallback() { clearInterval(this.timer); }
        now() { return new Date(Date.now() + this.offset * 3600e3); } // UTC fields = store wall clock
        isOff(d) { return this.skipSun && d.getUTCDay() === 0; }
        addDays(d, n) {
          const x = new Date(d.getTime());
          let left = n;
          while (left > 0) {
            x.setUTCDate(x.getUTCDate() + 1);
            if (!this.isOff(x)) left--;
          }
          return x;
        }
        dates() {
          const n = this.now();
          let dispatch = new Date(n.getTime());
          const afterCut = n.getUTCHours() >= this.cut;
          if (afterCut || this.isOff(dispatch)) dispatch = this.addDays(dispatch, 1);
          const a = this.addDays(dispatch, this.min);
          const b = this.addDays(dispatch, this.max);
          const range = this.min === this.max ? this.df.format(a) : `${this.df.format(a)} – ${this.df.format(b)}`;
          return { n, afterCut, range, dispatchToday: !afterCut && !this.isOff(n) };
        }
        render() {
          const { n, range, dispatchToday } = this.dates();
          this.range = range;
          const eta = this.querySelector('[data-rr-eta]');
          if (eta && eta.dataset.text) eta.textContent = eta.dataset.text.replace('[dates]', range);
          const cut = this.querySelector('[data-rr-cutoff]');
          const line = this.querySelector('[data-rr-cutoff-line]');
          if (!cut) return;
          if (dispatchToday && cut.dataset.before) {
            const left = this.cut * 3600 - (n.getUTCHours() * 3600 + n.getUTCMinutes() * 60 + n.getUTCSeconds());
            const h = Math.floor(left / 3600);
            const m = Math.max(1, Math.ceil((left % 3600) / 60));
            const html = cut.dataset.before.split('[countdown]');
            cut.textContent = '';
            cut.append(html[0]);
            const strong = document.createElement('strong');
            strong.textContent = h > 0 ? `${h}h ${m}m` : `${m}m`;
            cut.append(strong, html[1] || '');
          } else cut.textContent = cut.dataset.after || '';
          if (line) line.hidden = !cut.textContent.trim();
        }
        checkPin(form) {
          const input = form.querySelector('input');
          const msg = form.querySelector('.rr-pincode__msg');
          const v = (input.value || '').replace(/\s/g, '');
          const ok = /^[1-9][0-9]{5}$/.test(v);
          input.setAttribute('aria-invalid', ok ? 'false' : 'true');
          msg.classList.toggle('is-error', !ok);
          msg.textContent = ok
            ? (msg.dataset.ok || '').replace('[pincode]', v).replace('[dates]', this.range || this.dates().range)
            : msg.dataset.error || '';
        }
      }
    );
  }

  /* ---------- complete the look (complementary recommendations) ---------- */
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (url, w) => (url ? `${url.startsWith('//') ? 'https:' + url : url}${url.includes('?') ? '&' : '?'}width=${w}` : '');
  const renderMini = (p, labels) => {
    const single = p.variants && p.variants.length === 1 && /default title/i.test(p.variants[0].title);
    const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0];
    const img = p.featured_image
      ? `<img src="${sized(p.featured_image, 240)}" srcset="${sized(p.featured_image, 120)} 120w, ${sized(p.featured_image, 240)} 240w" sizes="80px" width="240" height="240" loading="lazy" alt="">`
      : '';
    let action;
    if (p.available && single) {
      action = `<button type="button" class="rr-mini__add" data-rr-add="${v.id}" aria-label="${esc(labels.add)}: ${esc(p.title)}"><svg class="rr-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg><span>${esc(labels.add)}</span></button>`;
    } else if (p.available) {
      action = `<a class="rr-mini__add" href="${esc(p.url)}"><span>${esc(labels.options)}</span><span class="visually-hidden">: ${esc(p.title)}</span></a>`;
    } else action = `<span class="rr-mini__soldout">${esc(labels.soldout)}</span>`;
    const compare = p.compare_at_price > p.price ? `<s>${formatMoney(p.compare_at_price)}</s> ` : '';
    return `<li class="rr-mini"><a class="rr-mini__media" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">${img}</a><div class="rr-mini__info"><a class="rr-mini__title" href="${esc(p.url)}">${esc(p.title)}</a><span class="rr-mini__price">${compare}${formatMoney(p.price)}</span></div>${action}</li>`;
  };
  window.ReyaRenderMini = renderMini;

  if (!customElements.get('rr-complete-look')) {
    customElements.define(
      'rr-complete-look',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.recs !== 'true' || this._loaded) return;
          this._loaded = true;
          const load = () =>
            fetch(this.dataset.url)
              .then((r) => r.json())
              .then((d) => {
                const list = (d.products || []).filter((p) => p.available !== undefined);
                if (!list.length) return this.remove();
                const labels = { add: this.dataset.addLabel, options: this.dataset.optionsLabel, soldout: this.dataset.soldoutLabel };
                this.querySelector('[data-rr-ctl-list]').innerHTML = list.map((p) => renderMini(p, labels)).join('');
                this.hidden = false;
              })
              .catch(() => this.remove());
          if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((en) => {
              if (en.some((x) => x.isIntersecting)) { io.disconnect(); load(); }
            }, { rootMargin: '400px 0px' });
            io.observe(this.parentElement || this);
          } else load();
        }
      }
    );
  }

  /* ---------- sticky add to cart ---------- */
  if (!customElements.get('rr-sticky-atc')) {
    customElements.define(
      'rr-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          const sec = this.dataset.section;
          this.btn = this.querySelector('[data-rr-sticky-add]');
          this.label = this.querySelector('[data-rr-sticky-label]');
          this.price = this.querySelector('[data-rr-sticky-price]');
          this.select = this.querySelector('[data-rr-sticky-variant]');
          this.main = () => document.getElementById(`ProductSubmitButton-${sec}`);
          const target = document.querySelector(`#MainProduct-${sec} product-form`) || this.main();
          if (!target || !('IntersectionObserver' in window)) return;
          this.io = new IntersectionObserver(([en]) => {
            const show = !en.isIntersecting && en.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', show);
            document.body.classList.toggle('rr-has-sticky-atc', show);
            if (show) this.removeAttribute('inert');
            else this.setAttribute('inert', '');
          });
          this.io.observe(target);

          this.btn.addEventListener('click', () => {
            const m = this.main();
            if (m && !m.disabled && m.getAttribute('aria-disabled') !== 'true') m.click();
            else (m || target).scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
          if (this.select) this.select.addEventListener('change', () => this.syncPicker());
          this.unsub = onVariant((d) => {
            if (d.sectionId && d.sectionId !== sec) return;
            const v = d.variant;
            if (v && this.price) this.price.textContent = formatMoney(v.price);
            if (v && this.select) this.select.value = v.id;
            requestAnimationFrame(() => {
              const m = this.main();
              if (!m) return;
              const disabled = m.disabled;
              this.btn.disabled = disabled;
              this.label.textContent = disabled ? m.textContent.trim() : this.dataset.label;
            });
          });
        }
        disconnectedCallback() {
          this.io && this.io.disconnect();
          this.unsub && this.unsub();
          document.body.classList.remove('rr-has-sticky-atc');
        }
        syncPicker() {
          const opt = this.select.selectedOptions[0];
          if (!opt) return;
          const values = (opt.dataset.options || '').split('||');
          const picker = document.getElementById(`variant-selects-${this.dataset.section}`);
          if (!picker) return;
          const groups = picker.querySelectorAll('fieldset, .product-form__input--dropdown');
          let last = null;
          groups.forEach((g, i) => {
            const val = values[i];
            if (val == null) return;
            const sel = g.querySelector('select');
            if (sel) {
              const o = Array.from(sel.options).find((x) => x.value === val || x.textContent.trim() === val);
              if (o && sel.value !== o.value) { sel.value = o.value; last = sel; }
            } else {
              const r = Array.from(g.querySelectorAll('input[type="radio"]')).find((x) => x.value === val);
              if (r && !r.checked) { r.checked = true; last = r; }
            }
          });
          if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }

  /* ---------- bundle builder ---------- */
  if (!customElements.get('rr-bundle')) {
    customElements.define(
      'rr-bundle',
      class extends HTMLElement {
        connectedCallback() {
          this.total = this.querySelector('[data-rr-bundle-total]');
          this.count = this.querySelector('[data-rr-bundle-count]');
          this.btn = this.querySelector('[data-rr-bundle-add]');
          this.addEventListener('change', (e) => {
            const sel = e.target.closest('[data-rr-bundle-variant]');
            if (sel) {
              const cb = sel.closest('.rr-bundle__item').querySelector('[data-rr-bundle-check]');
              const o = sel.selectedOptions[0];
              cb.value = o.value;
              cb.dataset.price = o.dataset.price;
              cb.closest('.rr-bundle__item').querySelector('[data-rr-bundle-price]').textContent = formatMoney(+o.dataset.price);
            }
            this.update();
          });
          this.btn && this.btn.addEventListener('click', () => {
            const items = this.checked().map((c) => ({ id: +c.value, quantity: 1 }));
            if (items.length) window.ReyaCart.add(items, this.btn);
          });
          const sec = this.dataset.productSection;
          this.unsub = onVariant((d) => {
            if (!d.variant || (sec && d.sectionId !== sec)) return;
            const cb = this.querySelector('[data-rr-bundle-current]');
            if (!cb) return;
            cb.value = d.variant.id;
            cb.dataset.price = d.variant.price;
            cb.disabled = !d.variant.available;
            if (!d.variant.available) cb.checked = false;
            const p = cb.closest('.rr-bundle__item').querySelector('[data-rr-bundle-price]');
            if (p) p.textContent = formatMoney(d.variant.price);
            this.update();
          });
          this.update();
        }
        disconnectedCallback() { this.unsub && this.unsub(); }
        checked() { return Array.from(this.querySelectorAll('[data-rr-bundle-check]:checked:not(:disabled)')); }
        update() {
          const c = this.checked();
          const sum = c.reduce((a, x) => a + (+x.dataset.price || 0), 0);
          if (this.total) this.total.textContent = formatMoney(sum);
          if (this.count) this.count.textContent = c.length;
          if (this.btn) this.btn.disabled = !c.length;
          this.querySelectorAll('.rr-bundle__item').forEach((it) => {
            const cb = it.querySelector('[data-rr-bundle-check]');
            it.classList.toggle('is-off', !cb.checked);
          });
          this.querySelectorAll('[data-rr-bundle-visual] [data-index]').forEach((el) => {
            const cb = this.querySelector(`[data-rr-bundle-check][data-index="${el.dataset.index}"]`);
            el.classList.toggle('is-off', !cb || !cb.checked);
          });
        }
      }
    );
  }

  /* ---------- recently viewed ---------- */
  const RKEY = 'rr:recent';
  const readRecent = () => {
    try { return JSON.parse(localStorage.getItem(RKEY)) || []; } catch (e) { return []; }
  };
  const writeRecent = (l) => {
    try { localStorage.setItem(RKEY, JSON.stringify(l.slice(0, 16))); } catch (e) {}
  };
  const track = () => {
    const el = document.querySelector('[data-rr-track-handle]');
    if (!el) return;
    const h = el.dataset.rrTrackHandle;
    writeRecent([h, ...readRecent().filter((x) => x !== h)]);
  };

  if (!customElements.get('rr-recently-viewed')) {
    customElements.define(
      'rr-recently-viewed',
      class extends HTMLElement {
        connectedCallback() {
          const load = () => this.load();
          if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((en) => {
              if (en.some((x) => x.isIntersecting)) { io.disconnect(); load(); }
            }, { rootMargin: '600px 0px' });
            io.observe(this);
          } else load();
        }
        async load() {
          const exclude = this.dataset.exclude;
          const limit = +this.dataset.limit || 8;
          const list = readRecent().filter((h) => h && h !== exclude).slice(0, limit);
          const track = this.querySelector('[data-rr-scroller]');
          const tpl = this.querySelector('template');
          if (!list.length || !track) return;
          const results = await Promise.all(
            list.map((h) =>
              fetch(`${root}products/${encodeURIComponent(h)}?section_id=${this.dataset.cardSection}`)
                .then((r) => (r.ok ? r.text() : null))
                .catch(() => null)
            )
          );
          const bad = [];
          const html = results
            .map((t, i) => {
              if (!t) { bad.push(list[i]); return ''; }
              const doc = new DOMParser().parseFromString(t, 'text/html');
              const card = doc.querySelector('[data-rr-card]');
              if (!card || !card.innerHTML.trim()) return '';
              return this.dataset.wrap === 'false' ? card.innerHTML : `<li class="rr-rv__item">${card.innerHTML}</li>`;
            })
            .join('');
          if (bad.length) writeRecent(readRecent().filter((h) => !bad.includes(h)));
          if (!html) return;
          track.innerHTML = html;
          this.hidden = false;
          const section = this.closest('.shopify-section');
          section && section.classList.remove('rr-rv--empty');
          window.Reya && window.Reya.initScrollers && window.Reya.initScrollers(this);
          window.Reya && window.Reya.initReveal && window.Reya.initReveal(this);
          tpl && tpl.remove();
        }
      }
    );
  }

  /* ---------- recommendations loaded by Dawn: wire Reya scrollers ---------- */
  const watchRecs = (scope = document) => {
    scope.querySelectorAll('[data-rr-recs]').forEach((el) => {
      if (el._rrWatch) return;
      el._rrWatch = new MutationObserver(() => {
        window.Reya && window.Reya.initScrollers && window.Reya.initScrollers(el);
        window.Reya && window.Reya.initReveal && window.Reya.initReveal(el);
      });
      el._rrWatch.observe(el, { childList: true });
    });
  };

  const start = () => {
    track();
    watchRecs();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (e) => watchRecs(e.target));
})();
